import { SumMoney } from 'model/Money'
import {
  FinancialDto,
  MoneyDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemTargetPriceSelector =
  (bomItemId: string, priceScope?: 'perUnit' | 'total') =>
  (state: RootAppState) => {
    const targetPrice = bomItemFinancialSelector(
      bomItemId,
      'targetSalesPricePerItem'
    )(state) as MoneyDto

    if (priceScope === 'total') {
      const totalProjectQuantity: number = bomItemFinancialSelector(
        bomItemId,
        'totalProjectQuantity'
      )(state) as unknown as number

      return {
        ...targetPrice,
        value: targetPrice.value * totalProjectQuantity,
      }
    }

    return targetPrice
  }

export const bomItemFinancialSum =
  (bomItemIds: string[], financialProp: keyof FinancialDto) =>
  (state: RootAppState) => {
    if (!state.project.activeProject?.id) {
      return null
    }

    const total = bomItemIds.reduce((acc, bomItemId) => {
      const financial = bomItemFinancialSelector(
        bomItemId,
        financialProp
      )(state)

      if (typeof financial[financialProp] === 'number') {
        return acc + financial[financialProp]
      } else if (Boolean(financial['currency'])) {
        return SumMoney([acc, financial])
      } else {
        console.warn(
          'financialProp is not a number or MoneyDto',
          financialProp,
          financial
        )
        throw new Error('Financial property is not a number or a MoneyDto')
      }
    }, {})

    return total
  }

export const bomItemFinancialSelector =
  (bomItemId: string, financialProp: keyof FinancialDto) =>
  (state: RootAppState) => {
    if (!state.project.activeProject?.id) {
      return null
    }

    if (bomItemId === state.project.activeProject?.id) {
      return state.project.activeProject.financial[financialProp]
    }

    const bomItem = bomItemSelector(state, bomItemId)

    switch (bomItem?.type) {
      case 'Assembly':
      case 'Row':
        return bomItem.financial[financialProp]
    }

    return null
  }
